import * as React from "react";
import { useMemo } from "react";
import { RowContainer } from "components/lookup-tables/layout-componets";
import usePluginEntities from "hooks/usePluginEntities";
import DataAdapter from "components/lookup-tables/DataAdapter";
function AdapterShow({ dataAdapter }) {
  var _a;
  const plugins = usePluginEntities("lookupTableAdapters");
  const adapterPlugin = useMemo(
    () => plugins.find((p) => {
      var _a2;
      return p.type === ((_a2 = dataAdapter == null ? void 0 : dataAdapter.config) == null ? void 0 : _a2.type);
    }),
    [(_a = dataAdapter == null ? void 0 : dataAdapter.config) == null ? void 0 : _a.type, plugins]
  );
  const DocComponent = useMemo(() => adapterPlugin == null ? void 0 : adapterPlugin.documentationComponent, [adapterPlugin]);
  return /* @__PURE__ */ React.createElement(RowContainer, { $gap: "xl", $withDocs: !!DocComponent, $justify: "center" }, /* @__PURE__ */ React.createElement("div", { style: { width: DocComponent ? "50%" : "100%" } }, /* @__PURE__ */ React.createElement(DataAdapter, { dataAdapter, noEdit: true })), DocComponent && /* @__PURE__ */ React.createElement("div", { style: { width: "50%" } }, /* @__PURE__ */ React.createElement(DocComponent, { dataAdapterId: dataAdapter == null ? void 0 : dataAdapter.id })));
}
export default AdapterShow;
